import styles from "./CopyErrorModal.module.scss";

interface CopyErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  textToCopy: string;
}

export function CopyErrorModal({
  isOpen,
  onClose,
  textToCopy,
}: CopyErrorModalProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modalWrapper} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h3 className={styles.title}>Не удалось скопировать</h3>
          <button className={styles.cross} onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <p className={styles.message}>Скопируйте текст вручную:</p>
        <input
          type="text"
          value={textToCopy}
          className={styles.input}
          onChange={() => {}}
        />
        <button onClick={onClose} className={styles.closeButton}>
          Закрыть
        </button>
      </div>
    </div>
  );
}
